import React from "react";
import MavDailyScans from "./MavDailyScans";
import MavSummary from "./MavSummary";
import MavTopRisks from "./MavTopRisks";

function MavRisk({ childTopRisks, childSummary, summaryLoading, riskLoading, isError, childScanReport, scanLoading }: any) {
    return (
        <div className="row">
            <MavSummary childSummary={childSummary} summaryLoading={summaryLoading} isError={isError} />
            <MavDailyScans childScanReport={childScanReport} scanLoading={scanLoading} isError={isError} />
            <MavTopRisks childTopRisks={childTopRisks} riskLoading={riskLoading} isError={isError} />
        </div>
    );
}

export default MavRisk;
